import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const TextSearch = ({ searchInput, setSearchInput }) => {
  const handleSearch = (event) => {
    event.preventDefault();

    // 全角を半角に変換
    const inputValue = event.target.value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });

    // 検索入力の状態を更新
    setSearchInput(inputValue);
  };

  return (
    <Box
      component='form'
      sx={{
        "& > :not(style)": { m: 1, width: "250px" },
      }}
      noValidate
      autoComplete='off'
    >
      <TextField
        id='outlined-basic'
        label='検索（車名または在庫NO）'
        variant='outlined'
        color='warning'
        onChange={handleSearch}
        onKeyDown={(event) => {
          // Enterキーが押されたときのデフォルトのイベントを無効にする
          if (event.key === "Enter") event.preventDefault();
        }}
      />
    </Box>
  );
};

export default TextSearch;
